import { AxiosRestApplicationClient as UserManagementAxiosRestApplicationClient } from '@g2-shared/api-client/generated/user-app';
import {
  generateBaseAxiosClient,
  INotificationService,
  NotificationsService,
} from '@g2-shared/common';

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const UserManagementApiClient = new UserManagementAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);

interface DIContextInterface {
  NotificationService: () => INotificationService;
  UserManagementApiClient: UserManagementAxiosRestApplicationClient;
}

export const DIContext = (): DIContextInterface => ({
  NotificationService: NotificationsService,
  UserManagementApiClient,
});
